import { PROJECTS_AREA_SEGMENTS } from "src/pages/projects/constants";

export const topLevelRoutes = [
  "onboarding",
  "syncs",
  "models",
  "destinations",
  "sources",
  "settings",
  "audiences",
  "extensions",
  "sequences",
  "partner-connect",
  "schema",
  "schema-v2",
  "analytics",
  "traits",
  "organization",
  "events",
  "partner",
  "home",
  "copilot",
  "journeys",
  "metrics",
  "governance",
  "invalid",
  "misc",
  "connections",
  "native-delivery",
  "ad-studio",
  ...PROJECTS_AREA_SEGMENTS,
  "context-hub",
];

// These routes we allow the current user request to 401 on without redirecting to login
export const unauthenticatedRoutes = [
  "login",
  "signup",
  "sso",
  "partner-connect",
  "invalid",
  "expired",
  "unauthorized",
];

export const homeRoute = "/home";
